import http from '@/service/http-service'

let resource = http.create({
  baseURL: http.defaults.baseURL,
  paramsSerializer: http.defaults.paramsSerializer
})
resource.interceptors.request.use(http.defaults.onReqSuccess, http.defaults.onReqError)
resource.interceptors.response.use(http.defaults.onResSuccess, http.defaults.onResError)

export default resource



// WEBPACK FOOTER //
// ./src/service/resource-service.js